
const getStatusLabel = {
  methods: {
    getStatusLabel(cert) {
      if (cert.status !== "active") {
        return "Revoked";
      }
      if (cert.validity === "expired") {
        return "Expired";
      }
      if (cert.validity === "notYetValid") {
        return "Not Active Yet";
      }
      return "Active";
    }
  }
}

const getStatusColor = {
  methods: {
    getStatusColor(cert) {
      if (cert.status !== "active") {
        return "#000000";
      }
      if (cert.validity === "expired") {
        return "#d72828";
      }
      if (cert.validity === "notYetValid") {
        return "#c6c9cc";
      }
      return "#31af91";
    },
  },
};

const getStatusIcon = {
  methods: {
    getStatusIcon(cert) {
      if (cert.status === "revoked" && cert.reason === "certificateHold") {
        return "fa-solid fa-circle-pause";
      }
      if (cert.status !== "active") {
        return "fa-solid fa-circle-minus";
      }
      if (cert.validity === "expired") {
        return "fa-solid fa-circle-exclamation";
      }
      if (cert.validity === "notYetValid") {
        return "fa-solid fa-clock";
      }
      return "fa-solid fa-circle-check";
    },
  },
};

export { getStatusLabel, getStatusColor, getStatusIcon };
